require('./reports.style.scss');
// const Report = require('../../model/Report');
const Filter = require('../../../shared/ctxFiltersPanel/ctxFilterModel');
const { permissions } = require('../../constants/permissions');

class ReportsController {
    constructor($scope, $filter, $stateParams, $timeout, $element, storageService, crudService, utilsService, reportsPersistence, styleService, notificationService, dialogService, iamPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$element = $element;
        this.storageService = storageService;
        this.crudService = crudService;
        this.utilsService = utilsService;
        this.reportsPersistence = reportsPersistence;
        this.notificationService = notificationService;
        this.iamPersistenceService = iamPersistenceService;
        this.dialogService = dialogService;
        this.isBackupAdmin = this.utilsService.isBackUpAdmin();
        this.inRole = utilsService.isUserRole();
        this.registerScope = this.$scope.$on('userGroup.changed', () => {
            this.refreshAfterSwitchUG();
        });

        this.selectedReports = [];
        this.selectedVersion = [];
        this.latestSelectedVersion = [];
        this.latestSelectedReport = [];

        this.isMini = false;
        this.isEditMode = false;
    }

    $onInit() {
        this.reportsPersistence.filterFlag = 0;
        this.load(true, true);
        this.reportsPersistence.filterFlag++;

        this.$scope.$watch(() => this.selectedVersion, (newValue, oldValue) => {
            if (oldValue !== newValue && newValue.length !== 0) this.latestSelectedVersion = newValue;
        });

        this.$scope.$watch(() => this.selectedReport, (newValue, oldValue) => {
            if (oldValue !== newValue && newValue.length !== 0) {
                this.latestSelectedReport = newValue;
                this.selectedVersion = [];
            }
        });

        this.$scope.$on('sub-changed', () => {
            this.load(true, true);
        });
    }

    openEditMode() {
        this.isEditMode = true;
        this.editorReport = this.selectedReports[0];
        this.showReportDialog = true;
        this.reportVersion = null;
        this.viewMode = null;
    }

    onEditorClose() {
        this.isEditMode = false;
    }

    filterRefresh() {
        this.load(true, null, true);
        this.reportsPersistence.filterFlag++;
    }

    load(firstPage, firstLoad, clearSelection, savedReport) {
        this.busy = true;
        if (clearSelection) {
            this.shownDetailsIndex = false;
            this.reportTitle = null;
            this.selectedReports = [];
        }
        this.reportsPersistence.load(firstPage).then(reports => {
            this.reports = !reports ? [] : reports;
            if (savedReport) {
                this.selectedReports = this.reports.filter(r => r.name === savedReport.name);
                if (!this.selectedReports[0]) {
                    this.shownDetailsIndex = false;
                    return;
                }
                this.selectedReports[0]._selected = true;
                this.showDetails(this.selectedReports[0], false);
            }
            for (let report of this.reports) {
                report.scheduledTooltip = report.scheduled ? this.$filter('translate')('report.table.scheduled') : this.$filter('translate')('report.table.unscheduled');
                report.subscribedTooltip = report.subscribed ? this.$filter('translate')('report.table.subscribed') : this.$filter('translate')('report.table.unsubscribed');
            }
            if (firstLoad && this.reports.length) {
                this.$timeout(() => {
                    this.reports[0]._selected = true;
                    this.selectedReports[0] = this.reports[0];
                    this.showDetails(this.reports[0]);
                }, 0);
            } else if (this.selectedReports && this.selectedReports.length) {
                this.$timeout(() => {
                    this.selectedReports = reports.filter(u => u.uuid === this.selectedReports[0].uuid);
                    if (!this.selectedReports[0]) {
                        this.shownDetailsIndex = false;
                        this.reportTitle = null;
                        return;
                    }
                    this.selectedReports[0]._selected = true;
                    if (this.shownDetailsIndex === this.selectedReports[0].uuid) {
                        this.showDetails(this.selectedReports[0]);
                    }
                }, 0);
            }
            this.busy = false;
        }, err => {
            this.busy = false;
            this.reports = [];
            this.selectedReports = [];
            this.selectedVersion = [];
            this.shownDetailsIndex = false;
            this.reportTitle = null;
        });
    }

    refreshAfterSwitchUG() {
        this.load(null, null, true);
        this.setGrid(this.grid, true);
        // this.setSubGrid(this.detailsGrid, true);
        // this.shownDetailsIndex = false;
        this.inRole = this.utilsService.isUserRole();
    }

    loadCreate() {
        this.editorReport = null;
        this.showReportDialog = true;
        this.reportVersion = null;
    }

    showDetails(item, firstLoad = true) {
        if (this.iamPersistenceService.hasPermissions(permissions.REPORT_DETAILS)) {
            this.shownDetailsIndex = item && item._selected ? item.uuid : false;
            this.selectedVersion = [];
            this.reportDetailsName = item.name;
            this.reportTitle = this.$filter('translate')('report.subTable.title', { name: this.reportDetailsName });
            if (!this.shownDetailsIndex) {
                this.isMini = false;
                return;
            }
            this.reportBusy = this.reportsPersistence.getReport(item, firstLoad).then(details => this.setReportDetails(details[0]), err => { }).finally(() => this.reportBusy = false);
        } else {
            this.shownDetailsIndex = item && item._selected ? item.uuid : false;

            this.isMini = false;
        }
    }

    setReportDetails(report) {
        this.selectedReport = report;
        this.formatDetailsData(report.config);
        const reportAggregation = report.config.vals.length ? ' - ' + String(report.config.vals).replace('Duration s', 'Job duration') : '';
        const xAxisValues = report.config.cols ? String(report.config.cols).replace(/,/g, ', ').replace('Tenant name', 'Owner').replace('Duration s', 'Job duration') : null;
        const yAxisValues = report.config.rows ? String(report.config.rows).replace(/,/g, ', ').replace('Tenant name', 'Owner').replace('Duration s', 'Job duration') : null;
        const timeRange = report.parameters.timeRange ? report.parameters.timeRange : 'All';
        this.reportDetails = [
            {
                detail: this.$filter('translate')('report.subTable.details.uuid.label'),
                value: report.uuid,
                id: 'report-uuid',
                icon: 'icon-copy'
            },
            {
                detail: this.$filter('translate')('report.subTable.details.type.label'),
                value: report.config.rendererName
            },
            // {
            //     detail: this.$filter('translate')('report.subTable.details.subscribed.label'),
            //     value: String(report.ifSubscribed)
            // },
            {
                detail: this.$filter('translate')('report.subTable.details.columns.label'),
                value: xAxisValues
            },
            {
                detail: this.$filter('translate')('report.subTable.details.rows.label'),
                value: yAxisValues
            },
            {
                detail: this.$filter('translate')('report.subTable.details.aggregation.label'),
                value: report.config.aggregatorName + reportAggregation
            },
            {
                detail: this.$filter('translate')('report.subTable.details.timeRange.label'),
                value: this.formatTimeRange(timeRange)
            },
        ];

        if (report.scheduleCron && Object.getOwnPropertyNames(report.scheduleCron).length !== 0) {
            let interval = report.scheduleCron.interval.toLowerCase();
            interval = interval.charAt(0).toUpperCase() + interval.slice(1);
            this.reportDetails.push(
                {
                    detail: this.$filter('translate')('report.subTable.details.scheduled.label'),
                    value: this.$filter('localizeDate')(report.scheduleCron.timestamp, 'short') + ' - ' + interval
                }
            )
        }
    }

    disableEditButtons(predifined) {
        return !this.selectedReports || !this.selectedReports[0] || !this.inRole.admin || (predifined ? this.selectedReports[0].predefined : false);
    }

    setGrid(grid, refresh) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('43%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('7%');
        // this.ctxGridStyleConfig.columnsWidthMapInPct.push('7%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        this.$timeout(() => {
            let user = this.storageService.getUser();
            this.grid.tableName = (refresh ? grid.tableId : this.grid.tableName) + '-' + user.username + '-' + user.userGroupName;
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    setSubGrid(grid, refresh) {
        this.detailsGrid = grid;
        this.ctxDetailsGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('20%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('25%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('55%');

        this.$timeout(() => {
            let user = this.storageService.getUser();
            this.detailsGrid.tableName = (refresh ? grid.tableId : this.detailsGrid.tableName) + '-' + user.username + '-' + user.userGroupName;
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName))) {
                this.ctxDetailsGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName);
            }
            this.detailsGridColumnsStyleConfig = this.ctxDetailsGridStyleConfig;
            this.detailsGridFlag = true;
        }, 0);
    }

    stateParamsFilterInit() {
        let statusFilter, createdFilter,
            stateParam = this.$stateParams.statusFilter,
            created = this.$stateParams.created;
        if (!stateParam && !created) return;

        this.eventsPersistence.clearFilter();

        if (stateParam) {
            statusFilter = this.eventsPersistence.filters.filter(item => item.filterKey === Event.getSeverityKey())[0];
            statusFilter.setOptionByValue(stateParam);
        }
        if (created) {
            createdFilter = this.eventsPersistence.filters.filter(item => item.filterKey === Event.getTimeRangeKey())[0];
            createdFilter.setOptionByValue(created);
        }
    }

    refreshVersions() {
        this.reportBusy = this.reportsPersistence.getReport(this.selectedReports[0], false).then(details => this.setReportDetails(details[0]), err => { });
    }

    filterRefresh() {
        // this.getEvents(true, null, true);
        this.reportsPersistence.filterFlag++;
    }

    del() {
        this.dialogService.showYesNo(this.$filter('translate')('report.deleteReport.dialog.text', { name: this.selectedReports[0].name }), this.$filter('translate')('report.deleteReport.dialog.title'), this.$filter('translate')('report.deleteReport.dialog.notice'), 'reports-delete')
            .then(result => {
                if (!result) return false;
                return this.busy = this.reportsPersistence.delReport(this.selectedReports[0]).then(resp => {
                    this.load(null, null, true);
                    this.notificationService.pop(resp.data.message);
                }, err => {
                });
            });
    }

    unschedule() {
        this.dialogService.showYesNo(this.$filter('translate')('report.unscheduleReport.dialog.text', { name: this.selectedReports[0].name }), this.$filter('translate')('report.unscheduleReport.dialog.title'), null, 'reports-unschedule')
            .then(result => {
                if (!result) return false;
                const data = {
                    ifScheduled: false
                };
                return this.busy = this.reportsPersistence.unscheduleReport(this.selectedReports[0], data).then(resp => {
                    this.load();
                    this.notificationService.pop(resp.data.message);
                }, err => {
                });
            });
    }

    unsubscribe() {
        this.dialogService.showYesNo(this.$filter('translate')('report.unsubscribeReport.dialog.text', { name: this.selectedReports[0].name }), this.$filter('translate')('report.unsubscribeReport.dialog.title'), null, 'reports-unsubscribe')
            .then(result => {
                if (!result) return false;
                const data = {
                    ifSubscribed: false
                };
                return this.busy = this.reportsPersistence.unsubscribeReport(this.selectedReports[0], data).then(resp => {
                    this.load();
                    this.notificationService.pop(resp.data.message);
                }, err => {
                });
            });
    }

    createVersion() {
        this.busy = this.reportsPersistence.getReport(this.selectedReports[0], false).then(details => this.setReportDetails(details[0]), err => { });
    }

    deleteVersion() {
        this.dialogService.showYesNo(this.$filter('translate')('report.deleteVersion.dialog.text'), this.$filter('translate')('report.deleteVersion.dialog.title'), null, 'reports-version-delete')
            .then(result => {
                if (!result) return false;
                return this.busy = this.reportsPersistence.deleteReportVersion(this.selectedReport, this.selectedVersion[0]).then(resp => {
                    this.reportsPersistence.getReport(this.selectedReports[0], false).then(details => this.setReportDetails(details[0]), err => { });
                    this.selectedVersion = [];
                    this.notificationService.pop(resp.data.message);
                }, err => {
                });
            });
    }

    openVersion() {
        this.editorReport = this.latestSelectedReport;
        this.showReportDialog = true;
        this.reportVersion = this.latestSelectedVersion[0];
        this.viewMode = true;
    }

    openPreview() {
        setTimeout(() => {
            this.viewMode = true;
            this.editorReport = this.latestSelectedReport;
            this.showReportDialog = true;
            this.reportVersion = null;
        }, 100);
    }

    formatDetailsData(data) {
        data.cols.forEach((c, i) => { data.cols[i] = this.toSentanceCase(c) });
        data.rows.forEach((r, i) => { data.rows[i] = this.toSentanceCase(r) });
        data.vals.forEach((v, i) => { data.vals[i] = this.toSentanceCase(v) });
    }

    toSentanceCase(str) {
        str = str.toLowerCase().split('_');
        for (let i = 0; i < str.length; i++) {
            str[i] = i === 0 ? str[i].charAt(0).toUpperCase() + str[i].slice(1) : str[i];
            if (str[i] === 'Vm') {
                str[i] = str[i].toUpperCase();
            }
        }
        return str.join(' ')
    }

    formatTimeRange(range) {
        switch (range) {
            case 'LAST24H': return this.$filter('translate')('report.view.timeRange.option.last24h.label'); break;
            case 'LAST48H': return this.$filter('translate')('report.view.timeRange.option.last48h.label'); break;
            case 'LAST7DAYS': return this.$filter('translate')('report.view.timeRange.option.last7days.label'); break;
            case 'PREVIOUSMONTH': return this.$filter('translate')('report.view.timeRange.option.previousMonth.label'); break;
            case 'PREVIOUSWEEK': return this.$filter('translate')('report.view.timeRange.option.previousWeek.label'); break;
            case 'PREVIOUSDAY': return this.$filter('translate')('report.view.timeRange.option.previousDay.label'); break;
            default: return this.$filter('translate')('report.view.timeRange.option.all.label'); break;
        }
    }

    exportReport() {
        this.busy = this.crudService.get('reports' + `/${encodeURI(this.selectedReport.uuid)}` + '/export', true, true).then(resp => {
            this.fileName = 'report_' + this.$filter('date')(new Date(), 'yyyyMMdd_HHmmss', 'UTC') + '.json';
            this.utilsService.saveData(resp.data, this.fileName, 'application/json');
        }).finally(() => {
            this.busy = false;
        });
    }

    onExport(type) {
        this.busy = true;
        return this.reportsPersistence[type === 'all' ? 'getAllReports' : 'load'](null, this.reportsPersistence.filters, { isExport: true }).then(res => {
            return res.map(item => {
                let result = {};
                result['name'] = item.name;
                result['scheduled'] = item.scheduled;
                result['description'] = item.description;
                return result;
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    isReportPreviewDisabled() {
        return !this.hasReportPreviewPermissions() || !this.selectedReports[0];
    }

    isCreateReportDisabled() {
        return !this.hasCreateReportPermissions();
    }

    isUpdateReportDisabled() {
        return !this.hasUpdateReportPermissions() || !this.selectedReports || !this.selectedReports[0];
    }

    isDeleteReportDisabled() {
        return !this.hasDeleteReportPermissions() || !this.selectedReports || !this.selectedReports[0] || this.selectedReports[0].predefined;
    }

    isReportScheduleDisabled() {
        return !this.hasReportSchedulePermissions() || !this.selectedReports || !this.selectedReports[0];
    }

    isReportExportDisabled() {
        return !this.hasReportExportPermissions() || !this.selectedReports || !this.selectedReports[0];
    }

    isReportImportDisabled() {
        return !this.hasReportImportPermissions();
    }

    isPreviewReportVersionDisabled() {
        return !this.hasPreviewReportVersionPermissions() || !this.selectedVersion || !this.selectedVersion[0];
    }

    isGenerateVersionDisabled() {
        return !this.hasGenerateVersionPermissions();
    }

    isDeleteVersionDisabled() {
        return !this.hasDeleteVersionPermissions() || !this.selectedVersion || !this.selectedVersion[0];
    }

    hasDeleteVersionPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_VERSION_DELETE)
    }

    hasGenerateVersionPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_VERSION_CREATE);
    }

    hasPreviewReportVersionPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_VERSIONS_VIEW);
    }

    hasReportImportPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_IMPORT);
    }

    hasReportExportPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_EXPORT);
    }

    hasReportSchedulePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_SCHEDULE);
    }

    hasDeleteReportPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_DELETE);
    }

    hasUpdateReportPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_UPDATE);
    }

    hasCreateReportPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_CREATE);
    }

    hasReportPreviewPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_PREVIEW);
    }

    hasReportsListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_LISTING);
    }

    hasReportDetailsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.REPORT_DETAILS);
    }

}

const reportsComponent = {
    controller: ReportsController,
    template: require('./reports.template.html')
};

ReportsController.$inject = ['$scope', '$filter', '$stateParams', '$timeout', '$element', 'storageService', 'crudService', 'utilsService', 'reportsPersistence', 'styleService', 'notificationService', 'dialogService', 'iamPersistenceService'];

module.exports = reportsComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/reports.component.js